<div class="p-g p-2">
  <h3 class="p-g-12 uppercase m-0 admin-dash-stats-label text-left">{{headerStr}}</h3>
  <div class="p-g-8">
    <p-chart height="200" type="bar" [data]="buildData" [options]="options"></p-chart>
  </div>
  <div class="p-g-4">
    <div class="p-g-12">
      <fieldset>
        <legend translate>label_legend_date_type</legend>
        <input type="radio" id="journeyDate" (click)="refreshData('journey')" name="dateType" value="journey" [checked]="dateType==='journey'" />
        <label for="journeyDate" translate> label_journey_date</label>
        <input type="radio" class="mrg-left-10" id="bookingDate" (click)="refreshData('booking')" name="dateType" value="booking" [checked]="dateType==='booking'"/>
        <label for="bookingDate" translate> label_booking_date </label>
      </fieldset>
    </div>
    <label for="selectedMonth" translate>label_month</label>
    <p-autoComplete [dropdown]="true"#monthAutoComplete class="autocomplete" field="label" inputId="selectedMonth"
      [(ngModel)]="selectedMonth"
      (onSelect)="changeMonth($event)" [suggestions]="monthSuggestions"
      [emptyMessage]="monthSuggestions.length?'':'label_empty_message'|translate" (completeMethod)="filterMonth($event)"
      (onClear)="changeMonth()" [size]="30" [minLength]="0" [placeholder]="'label_month' | translate"
      [forceSelection]="true" [autoHighlight]="true">
      <ng-template let-month pTemplate="item">
        <div class="autocomplete-list-item">
          {{ month.label }}
        </div>
      </ng-template>
    </p-autoComplete>
    <label for="selectedYear" translate>label_year</label>
    <p-autoComplete [dropdown]="true"#yearAutoComplete class="autocomplete" field="label" inputId="selectedYear"
      [(ngModel)]="selectedYear"
      (onSelect)="changeYear($event)" [suggestions]="yearSuggestions"
      [emptyMessage]="yearSuggestions.length?'':'label_empty_message'|translate" (completeMethod)="filterYear($event)"
      (onClear)="changeYear()" [size]="30" [minLength]="0" [placeholder]="'label_year' | translate"
      [forceSelection]="true" [autoHighlight]="true">
      <ng-template let-year pTemplate="item">
        <div class="autocomplete-list-item">
          {{ year.label }}
        </div>
      </ng-template>
    </p-autoComplete>

  </div>
</div>
